import React from 'react';

const Footer: React.FC = () => {
  // Email obfuscation is now handled directly in the onClick handler

  return (
    <footer className="bg-dark text-white py-5">
      <div className="container">
        <div className="row justify-content-between">
          {/* Company Info */}
          <div className="col-lg-4 col-md-4 mb-4 text-start">
            <div className="mb-3">
              <img
                src="/images/logo/OBM_logo_wtext_horizontal.png"
                alt="Ocean BioMetrics Logo"
                style={{ height: '40px' }}
              />
            </div>
            <p className="text-muted mb-3">
              Transforming ocean intelligence into actionable insights for conservation and regenerative blue finance.
            </p>

            {/* Social Media Icons */}
            <div className="social-links">
              <a
                href="https://www.linkedin.com/company/ocean-biometrics"
                className="text-light me-3 social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin fa-2x"></i>
              </a>
              <a
                href="https://github.com/ocean-biometrics/"
                className="text-light me-3 social-icon"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <i className="fab fa-github fa-2x"></i>
              </a>
              <button
                id="footer-email-link"
                className="text-light social-icon border-0 bg-transparent p-0"
                aria-label="Email"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  const parts = ['info', '@', 'ocean', 'bio', 'metrics', '.', 'com'];
                  const email = parts.join('');
                  window.location.href = `mailto:${email}`;
                }}
              >
                <i className="fas fa-envelope fa-2x"></i>
              </button>
            </div>
          </div>

          {/* Company Links */}
          <div className="col-lg-4 col-md-4 col-6 mb-4 company-column text-center">
            <h6 className="text-uppercase">Company</h6>
            <ul className="list-unstyled text-start">
              <li className="mb-2">
                <a href="/#about" className="text-muted text-decoration-none hover-primary">About</a>
              </li>
              <li className="mb-2">
                <a href="/team" className="text-muted text-decoration-none hover-primary">Team</a>
              </li>
              <li className="mb-2">
                <a href="/#contact" className="text-muted text-decoration-none hover-primary">Contact</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-lg-4 col-md-4 col-6 mb-4 legal-column text-end">
            <h6 className="text-uppercase text-start">Legal</h6>
            <ul className="list-unstyled text-start">
              <li className="mb-2">
                <a
                  href="/privacy-policy"
                  className="text-muted text-decoration-none hover-primary"
                >
                  Privacy Policy
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="/terms-of-service"
                  className="text-muted text-decoration-none hover-primary"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-4">
          <p className="mb-0 text-muted">
            &copy; 2025 Ocean BioMetrics Ltd. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;